export const ROLES = {
  SYSTEM_ADMINISTRATOR: 1,
  ADMINISTRATOR: 2,
  TEAM_LEAD: 3,
  PHYSICIAN_ADVISOR: 4,
  MID_LEVEL_REVIEWER: 5,
  TRAINER: 6,
  TRAINEE: 7,
  SUPPORT: 8,
  AUDITOR: 9,
};

export const REVIEW_STATUSES = {
  IN_PROGRESS: 1,
  PENDING: 2,
  FINAL: 3,
};

export const REVIEW_STATUSES_STRING = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  PENDING: 'Pending',
};

export const CPB_REVIEW_STATUSES_STRING_BY_ID = {
  1: 'In Progress',
  2: 'Pending',
  3: '',
  0: '',
};

export const REVIEW_TYPES = {
  INITIAL: 1,
  CONTINUED_STAY: 2,
  INITIAL_PA_REVIEW: 3,
  APPEAL_RETROSPECTIVE: 4,
  XSOLIS_INTERNAL: 5,
  PA_TASK_RESOLUTION: 6,
  CONTINUED_STAY_PA_REVIEW: 7,
  ESCALATE_FOR_PEER_TO_PEER: 8,
  PEER_TO_PEER: 9,
  FINAL_STATUS: 10,
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER: 11,
  PEER_TO_PEER_XSOLIS_PA: 12,
  PAYER_REVIEW: 13,
  EMERGENCY_DEPARTMENT: 14,
  PAYER_AUDIT: 15,
  MANUAL: 99,
};

export const REVIEW_SYSTEM_NAMES = {
  INITIAL: 'INT',
  CONTINUED_STAY: 'CST',
  INITIAL_PA: 'PA_INT',
  APPEAL_RETROSPECTIVE: 'ART',
  APPEAL_RETROSPECTIVE_PA: 'PA_ART',
  XSOLIS_INTERNAL: 'XIN',
  PA_TASK_RESOLUTION: 'PAR',
  PEER_TO_PEER_TASK_RESOLUTION: 'PPR',
  EMERGENCY_DEPARTMENT: 'EDP',
  CONTINUED_STAY_PA_REVIEW: 'PA_CST',
  ESCALATE_FOR_PEER_TO_PEER: 'EPP',
  PEER_TO_PEER: 'PA_PTP',
  PEER_TO_PEER_XSOLIS_PA: 'PA_PPX',
  FINAL_STATUS: 'FST',
  PAYER_REVIEW: 'AU_PYR',
  AUTO_ASSIGN_TO_PAYER: 'AAP',
};

export const REVIEW_TYPES_RR_STRING = {
  AUTO_ASSIGN_TO_PAYER: 'Auto-Assign To Payer',
  INITIAL_PA: 'Initial PA Review',
  CONTINUED_STAY_PA: 'Continued Stay PA',
  APPEAL_RETROSPECTIVE_PA: 'Appeal/Retrospective PA',
  PEER_TO_PEER_PA: 'Peer-to-Peer PA',
  PEER_TO_PEER_XSOLIS_PA: 'Peer-to-Peer XSOLIS PA',
  PA_TASK_RESOLUTION: 'PA Task Resolution',
  PEER_TO_PEER_TASK_RESOLUTION: 'Peer-To-Peer Task Resolution',
  EMERGENCY_DEPARTMENT: 'Emergency Department',
  INITIAL: 'Initial',
  CONTINUED_STAY: 'Continued Stay',
  ESCALATE_FOR_PEER_TO_PEER: 'Escalate for Peer-to-Peer',
  FINAL_STATUS: 'Final Status',
  APPEAL_RETROSPECTIVE: 'Appeal/Retrospective',
  XSOLIS_INTERNAL: 'XSOLIS Internal',
};

export const REVIEW_TYPES_UI_STRING = {
  AUTO_ASSIGN_TO_PAYER: 'Auto-Assign To Payer',
  INITIAL_PA: 'Initial PA Review',
  CONTINUED_STAY_PA: 'Continued Stay PA Review',
  APPEAL_RETROSPECTIVE_PA: 'Appeal/Retrospective',
  PEER_TO_PEER: 'Peer-to-Peer',
  PEER_TO_PEER_PA: 'Peer-to-Peer',
  PEER_TO_PEER_XSOLIS_PA: 'Peer-to-Peer XSOLIS PA',
  PA_TASK_RESOLUTION: 'PA Task Resolution',
  PEER_TO_PEER_TASK_RESOLUTION: 'Peer-To-Peer Task Resolution',
  EMERGENCY_DEPARTMENT: 'Emergency Department',
  INITIAL: 'Initial',
  CONTINUED_STAY: 'Continued Stay',
  ESCALATE_FOR_PEER_TO_PEER: 'Escalate for Peer-to-Peer',
  FINAL_STATUS: 'Final Status',
  APPEAL_RETROSPECTIVE: 'Appeal/Retrospective',
  XSOLIS_INTERNAL: 'XSOLIS Internal',
};

export const ADMISSION_STATUSES_RR_STRING = {
  INPATIENT: 'Inpatient',
  OUTPATIENT: 'Outpatient',
  EXTENDED_RECOVERY: 'Extended Recovery',
  OBSERVATION: 'Observation',
  UNABLE_TO_DETERMINE: 'Unable to Determine',
};

export const XSOLIS_USER_TYPE = 1;

export const CLINICAL_CATEGORIES = {
  CURRENT_HEALTH_INDICATORS: 'CurrentHealthIndicators',
  COMORBIDITIES_OR_PAST_MEDICAL_HISTORY: 'ComorbiditiesOrPastMedicalHistory',
  HIGH_RISK_HOME_MEDICATIONS: 'HighRiskHomeMedications',
  VITAL_SIGNS: 'VitalSigns',
  CBC: 'CBC',
  CMP: 'CMP',
  CARDIAC: 'Cardiac',
  OTHER: 'Other',
  ENDOCRINE: 'Endocrine',
  ABG: 'ABG',
};

export const MAX_REFERRAL_COMMENT_LENGTH = 250;
export const AUTOSAVE_INTERVAL_MS = 300;
export const AUTOSAVE_DRAGONFLY_INTERVAL_MS = 20000;
export const COMMENT_AUTOSAVE_INTERVAL = 1000;
export const QA_TEST_USERNAME = 'cortex-pa-automation-test@xsolis.com';
export const USER_TYPES_KEY = 'user-types';
export const SYSTEM_ADM = 'System Administrator';

export const FEATURES = {
  TEAMS_CREATE_NEW_USER_TYPE_AND_NEW_USER:
    'teams_create_new_user_type_and_new_user',
  QUEUE_PA_STATUS_INDICATOR_P2P: 'queue_pa_status_indicator_p2p',
  ADMIN_USER_TYPE_ORGANIZATION: 'admin_user_type_organization',
  PATIENT_EVENT_QUEUE: 'patient_event_queue',
  PARR_INTEROPERABILITY: 'parr_interoperability',
  PAM_PARITY: 'pa_merlot_parity',
  PARR_PARITY: 'pa_roadrunner_parity',
  PAM_CONNECTION: 'pa_merlot_connection',
  EVENT_REVIEW_AUTOSAVE: 'event_review_autosave',
  MERLOT_REVIEW_AUTOSAVE: 'review_autosave',
  ENABLE_LOS_DECIMAL: 'enable_los_decimal',
};

export const STEPS = {
  USER_DETAILS: 1,
  ROLES: 2,
};

export const P2P_OUTCOME_TYPES = {
  DENIAL_OVERTURNED: 6,
  DENIAL_UPHELD_FORMAL_APPEAL: 7,
  DENIAL_UPHELD_STATUS_DOWNGRADE: 8,
  P2P_NOT_PERFORMED_NOT_OFFERED: 9,
  P2P_NOT_PERFORMED_RECOMMEND_OUTPATIENT_OBSERVATION: 10,
  P2P_NOT_PERFORMED_PHYSICIAN_REFUSED: 11,
  P2P_NOT_PERFORMED_OVERTURNED_CLINICAL: 12,
  P2P_NOT_PERFORMED_NO_RESPONSE_APPEAL: 13,
  P2P_NOT_PERFORMED_NO_RESPONSE_NO_APPEAL: 14,
  OVERTURNED: 1,
  UPHELD: 2,
  PENDED: 3,
  DECLINED_P2P: 4,
  P2P_NOT_PERFORMED: 5,
};

export const PAYER_TYPE_CODES = {
  MEDICARE_PART_A: 'MA',
  MEDICARE_PART_B: 'MB',
  MEDICARE_ADVANTAGE: 'MV',
  MEDICAID: 'MC',
};

export const CURRENT_PATIENT_STATUSES = {
  INPATIENT: 1,
  OUTPATIENT: 2,
  EMERGENCY: 3,
  OBSERVATION: 4,
  DISCHARGED: 5,
  REGISTRATION: 6,
  INPATIENT_MO: 7,
  OBSERVATION_MO: 8,
  DISCHARGED_MO: 9,
  PREADMIT: 10,
};

export const REVIEW_CASE_STATUSES = {
  CORRECT: 1,
  INPATIENT: 11,
};

export const REVIEW_2ND_LEVEL_REASONS = {
  P2P_CONSIDERATION: 'Peer-to-Peer Consideration',
};

export const REVIEW_TYPES_REQUESTED = {
  STATUS_DETERMINATION: 'Status Determination',
  P2P: 'Peer-to-Peer',
  MANUAL: 'Manual',
  APPEAL_RETROSPECTIVE: 'Appeal/Retrospective',
};

export const LEVELS_OF_CARE = {
  INPATIENT_I: 1,
  OBSERVATION_I: 2,
  OUTPATIENT_I: 3,
  INSUFFICIENT_I: 4,
  INPATIENT_CS: 8,
  OBSERVATION_CS: 9,
  OUTPATIENT_CS: 10,
  INSUFFICIENT_CS: 11,
};

export const FINDINGS = {
  REQUEST_PA_P2P_I: 201,
  REQUEST_PA_P2P_CS: 202,
};

export const CHANGE_REVIEW_TYPE_MESSAGE = `Changing the review type will delete the review in progress and create a new review of the chosen type. Any content that can be transferred to the new review will be. This cannot be undone.`;

export const CANCEL_CHANGES_MESSAGE =
  'All changes you have made to this review will be discarded.';

export const REVIEW_WILL_BE_DELETED_MESSAGE =
  'You have changed the Review type for this review and selected Cancel. Are you sure you want to continue?  Selecting YES will DELETE this review, including all content. Selecting NO will return you to the review, where you may proceed with your change or edit the Review type.';

export const REVIEW_TYPE_SYSTEM_NAMES_UR_POP = [
  REVIEW_SYSTEM_NAMES.INITIAL,
  REVIEW_SYSTEM_NAMES.CONTINUED_STAY,
  REVIEW_SYSTEM_NAMES.APPEAL_RETROSPECTIVE,
  REVIEW_SYSTEM_NAMES.ESCALATE_FOR_PEER_TO_PEER,
];

export const REVIEW_TYPE_SYSTEM_NAMES_PA_POP = [
  REVIEW_SYSTEM_NAMES.INITIAL_PA,
  REVIEW_SYSTEM_NAMES.CONTINUED_STAY_PA_REVIEW,
  REVIEW_SYSTEM_NAMES.APPEAL_RETROSPECTIVE_PA,
  REVIEW_SYSTEM_NAMES.PEER_TO_PEER,
];

export const REVIEW_TYPE_SYSTEM_NAMES_PAYER_POP = [
  REVIEW_SYSTEM_NAMES.PAYER_REVIEW,
];

export const FONT_SIZE_MULTIPLIER_SETTINGS = {
  MIN: 0,
  MAX: 5,
};

export const FONT_SIZE_MULTIPLIER_OPTIONS = [
  { key: 'DEFAULT', text: 'DEFAULT', value: 0 },
  { key: '2X', text: '2X', value: 1 },
  { key: '3X', text: '3X', value: 2 },
  { key: '4X', text: '4X', value: 3 },
  { key: '5X', text: '5X', value: 4 },
  { key: '6X', text: '6X', value: 5 },
];

export const STORAGE_KEYS = {
  lastInvoiceParams: 'lastInvoiceParams',
  recentlyViewColumns: 'recently-view-columns',
};

export const DESKTOP_BREAKPOINT = 1180;

export const REVIEW_TYPE_SYSTEM_NAMES_UR = [
  REVIEW_SYSTEM_NAMES.PA_TASK_RESOLUTION,
  REVIEW_SYSTEM_NAMES.PEER_TO_PEER_TASK_RESOLUTION,
  REVIEW_SYSTEM_NAMES.EMERGENCY_DEPARTMENT,
  REVIEW_SYSTEM_NAMES.INITIAL,
  REVIEW_SYSTEM_NAMES.CONTINUED_STAY,
  REVIEW_SYSTEM_NAMES.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_SYSTEM_NAMES.FINAL_STATUS,
  REVIEW_SYSTEM_NAMES.APPEAL_RETROSPECTIVE,
  REVIEW_SYSTEM_NAMES.XSOLIS_INTERNAL,
  REVIEW_SYSTEM_NAMES.PAYER_REVIEW,
  REVIEW_SYSTEM_NAMES.AUTO_ASSIGN_TO_PAYER,
];
